// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"topicBodyComponentStyles_bodyWrapper__lSHUS"};